import {type FunctionalComponent, h} from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import type {IDashboardDesktopView} from '../dashboard-tab-view/dashboard-views/dashboard-desktop-view';

export interface NoResults extends Pick<IDashboardDesktopView, 'language' | 'isProductNaCountrySelector' | 'totalHits' | 'tabName' | 'brand' | 'isSupport'> {
    loading: boolean;
    labelProvider: labelProviderInterface;
    query: string;
    country?: string;
    globalDecommissioning?: boolean; // Remove after global decommissioning
    /*
    * List of locations where the searched product is available
    */
    productNaCountrySelectorLocales?: string;
    analyticsTabName?: string;
    rtl?: boolean;
    isSupport?: boolean;
}

export const NoResults: FunctionalComponent<NoResults> = (props) => {
    const { loading, query, labelProvider, globalDecommissioning, language, country, productNaCountrySelectorLocales, isProductNaCountrySelector, totalHits, analyticsTabName, tabName, brand, rtl, isSupport } = props;

    return (
      loading ? (
        ''
      ) : (
        <uiaas-search-no-results
          query={query}
          language={language}
          country={country}
          labelProvider={(e, f) =>
            labelProvider(e, f)
          }
          globalDecommissioning={globalDecommissioning}
          productNaCountrySelectorLocales={productNaCountrySelectorLocales}
          isProductNaCountrySelector={isProductNaCountrySelector}
          totalHits={totalHits}
          analyticsTabName={analyticsTabName}
          tabName={tabName}
          brand={brand}
          rtl={rtl}
          isSupport={isSupport}
        />
      )
    );
};
